import { render, staticRenderFns } from "./Step-3.vue?vue&type=template&id=af27df86&scoped=true&"
import script from "./Step-3.vue?vue&type=script&lang=js&"
export * from "./Step-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af27df86",
  null
  
)

export default component.exports